import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page62() {
  useEffect(() => {
    document.title = "Маяк — Страница 61"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page60" />
        <ForwardLink href="/page62" />
      </div>

      <p style={{ textAlign: "right" }}>61.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Пусть Нептун поразит тебя насмерть,<br/>
        Уинслоу!
      </p>
      <p>СТАРИК становится ужасно серьезным.</p>
      <p>МОЛОДОЙ напуган. Молчит.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК говорит сильнее и страстнее, чем любой<br/>
        Тамерлан или Лир. Он взывает к богам моря --<br/>
        одержимый человек:
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        Внимай, Тритон, Внимай!<br/>
        <br/>
        Кричите, и прикажите нашему отцу, морскому<br/>
        царю, подняться из глубин, в полной<br/>
        его ярости, черным волнам,<br/>
        изобилующим соленой пеной, и задушить<br/>
        этот молодой рот едкой<br/>
        слизью...<br/>
        (молодому)<br/>
        ... задушить тебя, наполняя твои<br/>
        органы, пока ты не посинеешь,<br/>
        не раздуешься от трюмной и соленой воды и<br/>
        больше не сможешь кричать... только тогда,<br/>
        когда он, увенчанный раковинами моллюсков,<br/>
        со скользящим хвостом, с щупальцами<br/>
        и дымящейся бородой, поднимется,<br/>
        рука с плавниками -- его коралловый<br/>
        трезубец скрипит как банши<br/>
        в буре и пронзит тебя через<br/>
        глотку, разрывая тебя, более<br/>
        не раздувшийся мочевой пузырь,<br/>
        а кровавую пленку -- ничто для<br/>
        гарпий и душ мертвых<br/>
        моряков, чтобы клевать, отрывать и есть,<br/>
        только то, чтобы быть слизанным<br/>
        и проглоченным бесконечным водами<br/>
        самого ужасного императора,<br/>
        забытый всеми людьми, во все времена,<br/>
        забытый любым богом или дьяволом,<br/>
        забытый даже морем... ибо<br/>
        любая вещь или часть Уинслоу, даже<br/>
        любая частичка твоей души<br/>
        больше не Уинслоу, а теперь само<br/>
        море.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК трясется как сумасшедший. Вены выступают во всех<br/>
        направлениях. Измотанный... глаза сверлят МОЛОДОГО.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ потеет. Что он может сделать? Что может сказать? Он<br/>
        проклят? Обречен?
      </p>
      <p style={{ textAlign: "right" }}>61.</p>

      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page60" />
        <ForwardLink href="/page62" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710629958/the-lighthouse-script/fo8iczils31z6b1jlqm5.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page62;
